export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.304.0-79ce952",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
